<template>
  <v-container>
    <SnapshotList></SnapshotList>
  </v-container>
</template>

<script setup lang="ts">
  import SnapshotList from '../project/SnapshotList.vue'
</script>
